<template>
  <div class="picking">
    <h3>Encomenda nº {{ orderId }}</h3>

    <!-- CABEÇALHO -->
    <b-container>
      <b-row class="title" align-v="center">
        <b-col cols="2">Data</b-col>
        <b-col cols="10">Artigos</b-col>
      </b-row>
    </b-container>
    <hr />

    <!-- ARTIGOS -->
    <b-container>
      <b-row align-v="center">
        <b-col cols="2" class="left">
          <p>{{ formatDate(order.date) }}</p>
        </b-col>
        <b-col cols="10">
          <div
            v-for="(article, index) in articles"
            :key="article.sku + '-' + (article.id_request || index)"
          >
            <p>
              <strong>{{ article.ordered }}</strong> x {{ article.sku }} -
              <a
                id="openArticle"
                v-b-modal.modal-3
                @click="passProductData(article)"
              >
                {{ article.name }}
              </a>
              - {{ article.price_eur }} € -
              <span v-if="article.picked == article.ordered">✔️</span>
              <span v-else style="color: red">
                (Pick: {{ article.picked }} |
                <span style="color: black">Stock: {{ article.stock }}</span
                >)
              </span>
            </p>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <hr />

    <!-- ENCOMENDAS JUNTAS + BOTÕES -->
    <b-row>
      <b-col cols="2"></b-col>
      <b-col cols="8" class="text-center">
        <div v-if="junt_id.length > 0">
          <p><b>Encomendas do mesmo cliente</b></p>
          <label>
            <input type="checkbox" v-model="ordersSeen" />
            Marcar como visto
          </label>
          <div class="junt-box">
            <span
              v-for="order in junt_id"
              :key="'junt_' + order"
              id="openArticle"
              v-b-modal.modal_encomenda
              @click="passOrderData1(order)"
            >
              [{{ order }}]
            </span>
          </div>
        </div>

        <!-- BOTÕES CENTRADOS -->
        <div class="text-center mt-3">
          <b-button
            v-if="order.status === 'packing'"
            id="next"
            class="mb-2 mx-1 custom-button custom-button-success"
            @click="checkPicking"
          >
            Seguinte
          </b-button>

          <router-link :to="'/newOrder/' + orderId">
            <b-button class="mb-2 mx-1 custom-button custom-button-join">
              Juntar Encomenda
            </b-button>
          </router-link>

          <router-link :to="'/editOrder/' + orderId">
            <b-button class="mb-2 mx-1 custom-button custom-button-warning">
              Editar Encomenda
            </b-button>
          </router-link>
          <!-- Botão para reverter encomendas clientes Virutal -->
          <b-button
            v-if="order.email == 'shebin.panikkaveetil@gmail.com'"
            class="mb-2 mx-1 custom-button custom-button-danger"
            variant="danger"
            @click="cancelClientOrder"
          >
            Reverter Encomenda
          </b-button>
        </div>
      </b-col>
      <b-col cols="2"></b-col>
    </b-row>

    <!-- MODAL PRODUTO -->
    <b-modal
      id="modal-3"
      ref="modal_product"
      title="Produto"
      size="lg"
      hide-footer
    >
      <div class="card">
        <b-container>
          <b-row align-v="center">
            <b-col class="left">
              <img :src="imgProduct" />
            </b-col>
            <b-col>
              <p><span id="subtitle">STOCK:</span> {{ stockProduct }}</p>
              <p><span id="subtitle">EAN:</span> {{ eanProduct }}</p>
              <p><span id="subtitle">SKU:</span> {{ skuProduct }}</p>
              <p><span id="subtitle">HS Code:</span> {{ hsProduct }}</p>
              <p><span id="subtitle">HS Code USA:</span> {{ hsProductUSA }}</p>
              <p>
                <span id="subtitle">Notas Arm.:</span> {{ warehouseProduct }}
              </p>
              <p><span id="subtitle">Notas:</span> {{ notesProduct }}</p>
              <p><span id="subtitle">Peso:</span> {{ weightProduct }}g</p>
              <b-button variant="primary" @click="openProdPage">
                Editar Produto
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </b-modal>

    <!-- MODAL ENCOMENDA JUNTADA -->
    <b-modal
      id="modal_encomenda"
      ref="modal_encomenda"
      :title="'Encomenda ' + modal_id"
      size="lg"
      hide-footer
    >
      <div class="card">
        <h5>Artigos</h5>
        <hr />
        <b-container>
          <b-row>
            <b-col>
              <p v-for="article in articles_modal" :key="article.sku">
                {{ article.quantity }} x {{ article.sku }} -
                <a
                  class="sku-link"
                  v-b-modal.modal-3
                  @click="passProductData(article)"
                >
                  {{ article.name }}
                </a>
              </p>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </b-modal>

    <!-- MODAL VISUALIZAR MENSAGENS -->
    <b-modal
      id="modal_confirm_msgs"
      title="Mensagens"
      size="lg"
      :hide-footer="true"
      :no-close-on-backdrop="disableClose"
      :no-close-on-esc="disableClose"
      :hide-header-close="disableClose"
      @shown="onModalShown"
      @hidden="onModalHiddenProceed"
    >
      <div
        ref="modalScrollBody"
        style="max-height: 50vh; overflow: auto; padding-right: 6px"
        @scroll="onModalScroll"
      >
        <h6 class="mb-2"><b>Mensagens internas</b></h6>
        <div v-if="hasInternalNotes">
          <ul class="pl-3 mb-3">
            <li v-for="(n, i) in order.notes" :key="'note_' + i">
              <b>{{ n.user || 'Utilizador' }}</b> — {{ n.comment || n }}
            </li>
          </ul>
        </div>
        <p v-else class="text-muted">Sem mensagens internas.</p>

        <h6 class="mb-2"><b>Mensagem do cliente</b></h6>
        <div v-if="hasCustomerNote" class="mb-3">
          {{ order.customer_note }}
        </div>
        <p v-else class="text-muted">Sem mensagem do cliente.</p>
      </div>

      <hr class="my-3" />

      <div class="d-flex justify-content-between align-items-center">
        <small v-if="requiresScroll && !hasScrolled" class="text-muted">
          Percorre até ao fim para poderes fechar.
        </small>
        <small v-else-if="!confirmDelayPassed" class="text-muted">
          Aguarda um momento…
        </small>
        <small v-else class="text-success">
          Podes fechar este pop-up para avançar.
        </small>

        <b-button
          variant="primary"
          :disabled="disableClose"
          @click="$bvModal.hide('modal_confirm_msgs')"
        >
          Fechar e avançar
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    orderId: String,
    articles: Array,
    order: Object,
    expeditionCreated: Boolean,
    allProducts: Array,
    amostraTotal: Number,
    limitTax: Number,
    junt_id: Array,
    filteredOrders: Array,
  },
  data: function () {
    return {
      picking: [],
      productsPicked: [],
      products: [],
      filterProducts: '',
      newOrder: true,
      disable: true,
      disableSave: true,
      eanProduct: '',
      skuProduct: '',
      hsProduct: '',
      hsProductUSA: '',
      warehouseProduct: '',
      notesProduct: '',
      weightProduct: '',
      imgProduct: '',
      idProduct: '',
      stockProduct: '',
      modal_id: '',
      articles_modal: [],
      wasInternReturn: false,
      ordersSeen: false,
      /* :disabled="disableSave == false"
      :disabled="disable == true" */

      // MODAL MENSAGENS
      disableClose: true, // bloqueia fecho do modal
      confirmDelayPassed: false, // pequeno delay anti-spam
      requiresScroll: false, // só se o conteúdo tiver overflow
      hasScrolled: false, // já chegou ao fundo
      confirmTimer: null, // handler do setTimeout
    };
  },
  methods: {
    async openProdPage() {
      window.open(
        `https://${window.location.host}/product/${this.idProduct}`,
        '_blank'
      );
      this.$refs['modal_product'].hide();
    },
    /* OBTER PRODUTOS DA ENCOMENDA */
    // async getProductsFromOrders() {
    //   try {
    //     await this.$store.dispatch('fetchOrderProducts');
    //     this.products = this.getOrderProducts.data;
    //   } catch (err) {
    //     alert(err);
    //   }
    //   if (!this.expeditionCreated) {
    //     await this.filterOrder();
    //   }
    // },

    async filterOrder() {
      /* FILTRAS POR ENCOMENDA */
      this.filterProducts = this.products.find(
        (product) => product.id_order == this.orderId
      );
      console.log(this.filterProducts);
      if (this.filterProducts != undefined) {
        /* if (this.filterProducts.picking) {
          console.log("TUDOOOO PICADOOOOO");
          this.$parent.productsOrderList();
        } else { */
        this.newOrder = false;
        for (let i = 0; i < this.articles.length; i++) {
          let x = this.filterProducts.products.includes(this.articles[i].sku);
          if (x) {
            this.picking.push(this.articles[i].sku);
          }
          console.log('FOR ARTICLES: ', this.articles);
        }
        console.log('PICKING: ', this.filterProducts.products.length);
        console.log('ARTIGOS: ', this.articles.length);
        if (this.filterProducts.products.length != 0) {
          console.log('TUDOOOO PICADOOOOO');
          this.$parent.productsOrderList();
        } /*  */
        /*  } */
      } else {
        this.newOrder = true;
        console.log(this.articles);
        /* for (let i = 0; i < this.articles.length; i++) {
          console.log(this.articles[i].quantity)
          for (let j = 0; j < this.articles[i].quantity; j++) {
            console.log("ENTROU")
            this.picking.push(this.articles[i].sku);
          }
        } */
        this.addProducts();
      }
    },
    /* ADICIONAR PRODUTO COMO FEITO O PICKING */
    addProducts() {
      this.productsPicked = [];
      let cont = 0;
      let quantity;
      let sku;
      for (let i = 0; i < this.articles.length; i++) {
        cont = 0;
        quantity = parseInt(this.articles[i].quantity);
        sku = this.articles[i].sku;
        for (let j = 0; j < this.picking.length; j++) {
          if (this.articles[i].sku == this.picking[j]) {
            for (let k = 0; k < quantity; k++) {
              cont = cont + 1;
              this.productsPicked.push(sku);
            }
          }
        }
      }
      if (this.picking.length == this.articles.length) {
        console.log();
        this.disable = false;
      } else {
        this.disable = true;
      }
      console.log(this.productsPicked);
    },
    /* GUARDAR O PICKING */
    // save() {
    //   if (this.newOrder == false) {
    //     this.updateProducts();
    //   } else if (this.newOrder == true && this.disable == false) {
    //     this.addToBD(true);
    //   } else {
    //     this.addToBD(false);
    //   }
    // },
    async checkPicking() {
      console.log(this.order);
      console.log('PICKING ', this.order.picking_done);
      if (this.order.send_email_address) {
        this.$swal({
          title: 'Verifique a morada antes de aceder à encomenda',
          icon: 'warning',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Ok!',
        });
      } else if (this.order.cs_lock) {
        this.$swal({
          title: 'A encomenda encontra-se bloqueada pelo CS!',
          icon: 'warning',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Vou verificar!',
        });
      } else if (
        !this.order.picking_done &&
        (this.order.id_invoice == null ||
          this.order.id_invoice == '' ||
          this.order.id_invoice == undefined)
      ) {
        this.$swal({
          title:
            'O picking da encomenda ainda não está completo nem existe fatura gerada!',
          icon: 'warning',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Vou verificar!',
        });
      } else if (this.junt_id.length > 0 && !this.ordersSeen) {
        this.$swal({
          title:
            'Você deve marcar as encomendas do mesmo cliente como visto para continuar!',
          icon: 'warning',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Vou verificar!',
        });
      } else {
        this.openMessagesModal();
      }
    },
    async confirmModal() {
      if (this.limitTax < this.amostraTotal) {
        this.$swal({
          title:
            'O valor da encomenda passa o limite de taxação, deseja continuar?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sim, continuar!',
          cancelButtonText: 'Cancelar',
        }).then(async (result) => {
          if (result.isConfirmed) {
            await this.$swal({
              title:
                'Insira o código de confirmação para criação de nova encomenda',
              html: `<input type="password" id="numberInvoice" class="form-control" v-model="teste" placeholder="Código">`,
              confirmButtonText: 'Confirmar',
              cancelButtonText: 'Cancelar',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              focusConfirm: false,
              preConfirm: () => {
                const code = this.$swal
                  .getPopup()
                  .querySelector('#numberInvoice').value;
                if (!code) {
                  this.$swal.showValidationMessage(
                    `Por favor preencha os campos corretamente`
                  );
                }
                return { code: code };
              },
            }).then(async (result2) => {
              if (result2.isConfirmed) {
                if (result2.value.code != 'confirmo') {
                  await this.$swal({
                    icon: 'error',
                    title: 'Código de confirmação inválido',
                    text: 'Encomenda não criada',
                  });
                } else {
                  this.next();
                }
              }
            });
          }
        });
      } else if (this.wasInternReturn) {
        this.$swal({
          title:
            'Esta encomenda já foi devolvida internamente, e mudança de morada foi efectuada!',
          text: 'Verifique a morada da fatura e caso tenha alterado efetua uma conta de crédito!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Continuar!',
          cancelButtonText: 'Cancelar',
        }).then((result) => {
          if (result.isConfirmed) {
            this.next();
          }
        });
      } else {
        this.next();
      }
    },
    /* AVANÇAR NO FORMULÁRIO */
    async next() {
      for (let i = 0; i < this.articles.length; i++) {
        console.log(this.articles[i].quantity);
        for (let j = 0; j < this.articles[i].quantity; j++) {
          console.log('ENTROU');
          this.picking.push(this.articles[i].sku);
        }
      }
      this.$parent.productsOrderList();
      // this.$root.$emit("component1");
    },

    // MODAL MENSAGENS
    openMessagesModal() {
      // ✅ se não há mensagens, não abre modal e avança já
      if (!this.hasAnyMessages) {
        this.confirmModal();
        return;
      }

      // reset flags
      this.disableClose = true;
      this.confirmDelayPassed = false;
      this.requiresScroll = false;
      this.hasScrolled = false;

      this.$bvModal.show('modal_confirm_msgs');
    },

    onModalShown() {
      // pequeno delay (1.2s) antes de permitir fechar
      this.confirmTimer && clearTimeout(this.confirmTimer);
      this.confirmTimer = setTimeout(() => {
        this.confirmDelayPassed = true;
        this.updateDisableClose();
      }, 1200);

      // detetar se precisa scroll (overflow)
      this.$nextTick(() => {
        const el = this.$refs.modalScrollBody;
        if (!el) return;
        this.requiresScroll = el.scrollHeight > el.clientHeight + 2;
        if (!this.requiresScroll) {
          this.hasScrolled = true;
          this.updateDisableClose();
        }
      });
    },

    onModalScroll(e) {
      const el = e.target;
      const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 2;
      if (atBottom) {
        this.hasScrolled = true;
        this.updateDisableClose();
      }
    },

    updateDisableClose() {
      // só permite fechar quando passou o delay e (se houver) fez scroll até ao fim
      this.disableClose = !(this.confirmDelayPassed && this.hasScrolled);
    },

    onModalHiddenProceed() {
      // limpar timers
      this.confirmTimer && clearTimeout(this.confirmTimer);
      this.confirmTimer = null;

      // ✅ depois de ver mensagens -> continua o teu fluxo atual
      this.confirmModal();
    },

    /* ATUALIZAR PRODUTOS */
    // async updateProducts() {
    //   try {
    //     await this.$store.dispatch("putOrderProducts", {
    //       id: this.orderId,
    //       products: this.productsPicked,
    //       picking: !this.disable,
    //     });
    //     this.$swal({
    //       toast: true,
    //       position: "top-end",
    //       icon: "success",
    //       title: "Produtos Guardados",
    //       showConfirmButton: false,
    //       timer: 1500,
    //     });
    //   } catch (err) {
    //     alert(err);
    //   }
    // },

    /* ADICIONAR OS PRODUTOS DA ENCOMENDA À BD */
    // async addToBD(disable) {
    //   try {
    //     await this.$store.dispatch("addOrderProducts", {
    //       id: this.orderId,
    //       products: this.productsPicked,
    //       picking: disable,
    //     });
    //   } catch (err) {
    //     alert(err);
    //   }
    // },

    // DADOS DA MODAL DO PRODUTO
    async passProductData(data) {
      // console.log('TODOS OS PRODUTOS: ', this.allProducts);
      // const filterProduct = this.allProducts.filter((product) => product.sku.includes(data.sku));
      this.eanProduct = data.ean;
      this.skuProduct = data.sku;
      this.hsProduct = data.hscode;
      this.hsProductUSA = data.hscodeusa;
      this.warehouseProduct = data.note_warehouse;
      this.notesProduct = data.note_finish;
      this.weightProduct = data.weight;
      this.imgProduct = data.img;
      this.idProduct = data.id_backoffice;
      this.stockProduct = data.stock;
      // console.log(filterProduct, data);
    },
    async passOrderData1(id) {
      const filterOrder = this.filteredOrders.filter((order) => order.id == id);
      console.log('FILTER ORDER: ', filterOrder);
      this.modal_id = filterOrder[0].id;
      this.articles_modal = JSON.parse(filterOrder[0].articles);
    },
    async checkInternReturn() {
      console.log('Check Intern Return');
      try {
        await this.$store.dispatch('checkIfWasInternReturn', {
          id: this.orderId,
        });
        this.wasInternReturn = this.getcheckIfWasInternReturn;
        console.log('Was returning: ', this.wasInternReturn);
      } catch (err) {
        this.$swal({
          toast: true,
          position: 'top-end',
          icon: 'error',
          title: err,
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },
    async cancelClientOrder() {
      this.$swal({
        title: 'Tem a certeza que deseja reverter a encomenda?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, reverter!',
        cancelButtonText: 'Cancelar',
      }).then(async (result) => {
        if (result.isConfirmed) {
          //Fazer a chamada para reverter encomenda
          const result = await fetch(
            `${this.$store.state.apiUrl}clientRequest/requests/logistics/cancel`,
            {
              method: 'PATCH',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${this.$store.state.token}`,
              },
              body: JSON.stringify({
                order_id: this.orderId,
              }),
            }
          );

          if (result.ok) {
            const data = await result.json();
            this.$swal.fire({
              icon: 'success',
              title: 'Encomenda revertida com sucesso!',
              text: data.message || 'Encomenda revertida com sucesso.',
              toast: true,
              timer: 3000,
              showConfirmButton: false,
              position: 'top-end',
            });

            this.$router.push('/orders');

            return;
          } else {
            const errorData = await result.json();
            this.$swal.fire({
              icon: 'error',
              title: 'Erro ao reverter encomenda',
              text: errorData.message || 'Erro desconhecido.',
              toast: true,
              timer: 3000,
              showConfirmButton: false,
              position: 'top-end',
            });
          }
        }
      });
    },
    formatDate(date) {
      if (!date) return '';
      return new Intl.DateTimeFormat('pt-PT').format(new Date(date));
    },
  },
  computed: {
    ...mapGetters(['getOrderProducts']),
    ...mapGetters(['getcheckIfWasInternReturn']),
    hasInternalNotes() {
      return Array.isArray(this.order?.notes) && this.order.notes.length > 0;
    },
    hasCustomerNote() {
      const cn = this.order?.customer_note;
      return cn !== undefined && cn !== null && String(cn).trim() !== '';
    },
    hasAnyMessages() {
      return this.hasInternalNotes || this.hasCustomerNote;
    },
  },
  async created() {
    await this.filterOrder();
    await this.checkInternReturn();
    console.log(this.order);
    console.log('ASDAS', this.articles);
  },
};
</script>

<style scoped>
.picking {
  padding: 25px;
  background-color: rgba(255, 147, 147, 0.733);
  margin: 0px 50px;
  border: 1px solid #dddd;
  border-radius: 18px;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}
h3 {
  color: white;
  margin-bottom: 20px;
}
p {
  text-align: center;
}
hr {
  background-color: white;
  height: 2px;
  border: 0;
}
button,
.b-button {
  background-color: rgb(104, 155, 75);
  border: none;
  margin-right: 5px;
}
button:hover,
.b-button:hover {
  background-color: rgba(104, 155, 75, 0.788);
  box-shadow: none;
}
button:focus,
.b-button:focus {
  box-shadow: none;
}
img {
  max-width: 100%;
  border-radius: 18px;
}
.card {
  padding: 25px;
  background-color: rgba(255, 147, 147, 0.733);
  margin: 0px 0px;
  border: 1px solid #dddd;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}
#subtitle {
  color: white;
  font-weight: bold;
}
#openArticle,
.sku-link {
  color: rgb(0, 98, 255);
  cursor: pointer;
}
#openArticle:hover,
.sku-link:hover {
  text-decoration: underline;
}
.title {
  text-align: center;
}
.junt-box {
  border: 3px solid red;
  border-radius: 5px;
  padding: 5px;
}

.custom-button {
  padding: 8px 16px;
  font-size: 14px;
  font-weight: bold;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
  border: none;
}

.custom-button-success {
  background-color: #28a745;
  color: white;
}

.custom-button-success:hover {
  background-color: #218838;
  transform: scale(1.02);
}

.custom-button-success:active {
  background-color: #1e7e34;
  transform: scale(0.98);
}

.custom-button-join {
  background-color: #007bff;
  color: white;
}

.custom-button-join:hover {
  background-color: #0069d9;
  transform: scale(1.02);
}

.custom-button-join:active {
  background-color: #0056b3;
  transform: scale(0.98);
}

.custom-button-warning {
  background-color: #ffc107;
  color: white;
}

.custom-button-warning:hover {
  background-color: #e0a800;
  transform: scale(1.02);
}

.custom-button-warning:active {
  background-color: #d39e00;
  transform: scale(0.98);
}

.custom-button-danger {
  background-color: #dc3545;
  color: white;
}

.custom-button-danger:hover {
  background-color: #c82333;
  transform: scale(1.02);
}

.custom-button-danger:active {
  background-color: #bd2130;
  transform: scale(0.98);
}
</style>
